<template>
  <v-card flat>
    <v-card-title v-if="!normalizationLoading">
      <v-row>
        <v-col align="center">
          <v-btn
            @click="normalizeConcept(conceptUuid)"
            color="primary"
            dark
          >Retry {{getElementByUuid(conceptUuid, concepts).label}}</v-btn>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-subtitle v-if="normalizationLoading" class="mt-4 py-0">
      <v-progress-linear striped :value="progress" color="green" height="12">
        <template v-slot="{ value }">
          <strong>{{ Math.ceil(value) }}%</strong>
        </template>
      </v-progress-linear>
    </v-card-subtitle>
    <v-card-subtitle v-if="normalizationLoading" class="my-0 py-0">
      <v-col align="center">
        <v-btn color="red" dark @click="stop">Stop</v-btn>
      </v-col>
    </v-card-subtitle>
    <v-card-text>
      <v-card>
        <v-overlay absolute :value="normalizationLoading">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-card-text>
          <v-data-iterator :items="orders" :search="search">
            <template v-slot:header>
              <v-toolbar dark color="red accent-2" class="mb-1">
                <v-text-field
                  v-model="search"
                  clearable
                  flat
                  solo-inverted
                  hide-details
                  color="red accent-2"
                  prepend-inner-icon="mdi-magnify"
                  label="Search"
                ></v-text-field>
              </v-toolbar>
            </template>
            <template v-slot:default="props">
              <v-row>
                <v-col v-for="order in props.items" :key="order.name" cols="12" sm="6">
                  <UncompletedCard :order="order" v-on:normalize="normalizeOrder" />
                </v-col>
              </v-row>
            </template>
          </v-data-iterator>
        </v-card-text>
      </v-card>
    </v-card-text>
  </v-card>
</template>

<script>
import UncompletedCard from "@/components/Uncompleted/UncompletedCard";

export default {
  components: { UncompletedCard },
  props: {
    normalizationLoading: { type: Boolean },
    conceptUuid: { type: String },
    concepts: { type: Array },
    progress: { type: Number },
    orders: { type: Array },
  },
  data: function () {
    return {
      search: "",
    };
  },
  methods: {
    stop() {
      this.$emit("stop");
    },
    normalizeOrder(uuid) {
      this.$emit("normalizeOrder", uuid);
    },
    normalizeConcept(conceptUuid) {
      this.$emit("normalizeConcept", conceptUuid);
    },
    getElementByUuid(uuid, list) {
      return list.find((obj) => obj.uuid === uuid);
    },
  },
};
</script>
